import { Licenses } from "../Data/Licenses.ts";
import { useParams } from "../Providers/ParamsProvider";

const useCheckLicense = () => {
  const { license, handleGetLicense } = useParams();

  const checkLicense = (allowedLicenses: Licenses[]): boolean => {
    // if (!license || license.trim() === "") {
    //   var downloaLicense = await handleGetLicense();
    //   if (!downloaLicense || downloaLicense.trim() === "") {
    //     return false;
    //   }
    // }
    if (!license || license.trim() === "") {
      return false;
    }
    if (license === Licenses.Ferrodo) {
      //wszystkie opcje dla ferrodo
      return true;
    }
    //var tmpLicense = downloaLicense?.trim() === "" ? license : downloaLicense;

    return allowedLicenses.includes(license as Licenses);
  };

  return { checkLicense };
};

export default useCheckLicense;
